import { useEffect } from 'react';
import { useRouter } from 'next/router';
import {
  extractUTMParams,
  storeUTMParams,
  UTMParams,
} from '@summer-health/shared/utils';
import { getLogger } from '@summer-health/shared/next-logger';

const logger = getLogger('utm-tracker');

export function UTMTracker(): null {
  const router = useRouter();

  useEffect(() => {
    try {
      // Check if we have UTM parameters in the URL
      if (typeof window !== 'undefined') {
        // Get standard UTM parameters
        const url = window.location.href;
        const standardUtmParams = extractUTMParams(url);

        // Also capture any other utm_* parameters that aren't in our standard list
        const urlObj = new URL(url);
        const allParams: UTMParams = { ...standardUtmParams };

        // Look for any URL parameter that starts with utm_
        urlObj.searchParams.forEach((value, key) => {
          if (key.startsWith('utm_') && !allParams[key]) {
            // This is a UTM parameter we didn't capture in our standard list
            allParams[key] = value;
            logger.info(`Captured additional UTM parameter: ${key}=${value}`);
          }
        });

        // Only store if we have at least one UTM parameter
        if (Object.values(allParams).some((value) => value !== undefined)) {
          logger.info({ ...allParams }, 'UTM parameters detected and stored');
          storeUTMParams(allParams);
        }
      }
    } catch (error) {
      logger.error({ error }, 'Failed to extract or store UTM parameters');
    }
  }, [router.asPath]);

  // This component doesn't render anything
  return null;
}
